import React from 'react';
import { motion } from 'framer-motion';
import { permission, snakMeta } from '../../../data/snak';
import { heroOct } from '../../../data/teaser';
const EASE = [0.23, 1, 0.32, 1] as const;
export function PermissionPage() {
  return <div className="flex flex-1" data-id="element-199" data-mp="ogug3163w4k3">
      <div className="flex flex-1 flex-col justify-center px-10 py-8" data-id="element-200" data-mp="ohm9q6g57s7q">
        <motion.p initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.24,
        ease: EASE
      }} className="flex items-center gap-2.5 text-[10px] uppercase tracking-micro text-blue" data-id="element-201" data-mp="temkgunxtj56">
          <span className="h-1.5 w-1.5 rounded-full bg-mint" aria-hidden="true" data-id="element-202" data-mp="17exc3zx2n1re" />
          {permission.eyebrow}
        </motion.p>

        <motion.h2 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        delay: 0.06,
        ease: EASE
      }} className="mt-5 max-w-lg font-display text-[44px] font-semibold leading-[0.98] tracking-tight text-navy" data-id="element-203" data-mp="1cbnrel11xtbr">
          Can I get your take on
          <br data-id="element-204" data-mp="olsej9o9eg95" />
          <span className="text-blue" data-id="element-205" data-mp="kmtdi05nf3mz">one OCT question?</span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.26,
        delay: 0.14,
        ease: EASE
      }} className="mt-6 max-w-sm text-[15px] leading-relaxed text-mut" data-id="element-206" data-mp="kkqfasuce476">
          {permission.support}
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.26,
        delay: 0.2,
        ease: EASE
      }} className="mt-8 border-l-2 border-mint pl-4 font-display text-[18px] leading-snug text-navy" data-id="element-207" data-mp="18dyuiinbs1yv">
          {snakMeta.principle}
        </motion.p>
      </div>

      <motion.figure initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.3,
      delay: 0.08,
      ease: EASE
    }} className="relative w-[46%] shrink-0 overflow-hidden bg-ink" data-id="element-208" data-mp="3j3dvr9y30ebv">
        <img src={heroOct.src} alt={heroOct.alt} className="fade-left absolute inset-0 h-full w-full object-cover opacity-90" data-id="element-209" data-mp="1i3iqldmn3ejl" />
        <div className="scanlines pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-210" data-mp="1rzvpcpx1kil7" />
        <figcaption className="absolute bottom-5 left-5 right-5 flex items-center gap-2 text-[9px] uppercase tracking-micro text-sky/70" data-id="element-211" data-mp="1w1z53qqqu9ca">
          <span className="h-px flex-1 bg-sky/25" aria-hidden="true" data-id="element-212" data-mp="210ju0u0jp6lf" />
          Routine OCT · diabetic macular oedema
        </figcaption>
      </motion.figure>
    </div>;
}